import { openAtom } from "@mongez/react-atom";

export const searchAtom = openAtom("search");
